import React, { useState, useEffect } from "react"
import axios from 'axios';
import {
    Col,
    Form,
    Row,
    Button,
} from "reactstrap"

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import PropTypes from 'prop-types';
import { technoProductsUrl, getCustomerTechnoProductDetailsUrl } from "../../helpers/fakebackend_helper";
import authHeader from "helpers/authHeader";

const TechnoProducts = ({ RegistrationId }) => {

    const formBackground = {
        borderRadius: 8,
        flex: 1,
        ////backgroundColor: "rgb(247 242 242)",
        padding: "15px"
    }

    const tabHeading = {
        color: "#9a084f",
        fontWeight: "bold"
    }

    const label = {
        color: "black"
    }

    const formButton = {
        marginLeft: "20px",
        backgroundColor: "#9a084f",
        fontSize: "small",
        borderRadius: "0.50rem"
    }

    const [branch, setBranch] = useState([]);
    const [showEasing, setshowEasing] = useState("swing");
    const [hideEasing, sethideEasing] = useState("linear");
    const [showMethod, setshowMethod] = useState("fadeIn");
    const [hideMethod, sethideMethod] = useState("fadeOut");
    const [showDuration, setshowDuration] = useState(300);
    const [hideDuration, sethideDuration] = useState(1000);
    const [timeOut, settimeOut] = useState(2000);
    const [extendedTimeOut, setextendedTimeOut] = useState(1000);

    function SuccessMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.success(message, "Information");
    }

    function ErrorMessage(message) {
        toastr.options = {
            positionClass: "toast-top-center",
            timeOut: timeOut,
            extendedTimeOut: extendedTimeOut,
            closeButton: true,
            debug: false,
            progressBar: false,
            preventDuplicates: false,
            newestOnTop: false,
            showEasing: showEasing,
            hideEasing: hideEasing,
            showMethod: showMethod,
            hideMethod: hideMethod,
            showDuration: showDuration,
            hideDuration: hideDuration
        };

        toastr.error(message, "Error");
    }

    const technoProducts = {
        RegistrationId: '',
        DebitCard: '',
        SMSBanking: '',
        MobileBanking: '',
        StatementOnEmail: '',
        AadhaarCardSeeding: '',
        InterntBanking: ''
    }

    useEffect(() => {
        GetCustomerTechnoProductDetails();
    }, []);

    function GetCustomerTechnoProductDetails() {
        const customerDetailModel = {
            RegistrationId: RegistrationId
        };

        axios.post(getCustomerTechnoProductDetailsUrl(), customerDetailModel, { headers: authHeader() })
            .then(response => {
                BindTectnoProductDetails(response.data);
            }, (error) => {
                console.log(error.response);
            })
    }

    function BindTectnoProductDetails(technoProductDetails) {
        if (technoProductDetails.length > 0) {
            if (technoProductDetails[0].debitCard) {
                $('#switchdebitcard').prop('checked', true);
            }
            else {
                $('#switchdebitcard').prop('checked', false);
            }

            if (technoProductDetails[0].smsBanking) {
                $('#switchsmsbanking').prop('checked', true);
            }
            else {
                $('#switchsmsbanking').prop('checked', false);
            }

            if (technoProductDetails[0].mobileBanking) {
                $('#switchmobilebanking').prop('checked', true);
            }
            else {
                $('#switchmobilebanking').prop('checked', false);
            }

            if (technoProductDetails[0].statementOnEmail) {
                $('#switchemail').prop('checked', true);
            }
            else {
                $('#switchemail').prop('checked', false);
            }

            if (technoProductDetails[0].aadhaarCardSeeding) {
                $('#switchaadhaarcard').prop('checked', true);
            }
            else {
                $('#switchaadhaarcard').prop('checked', false);
            }

            if (technoProductDetails[0].interntBanking) {
                $('#switchinternetbanking').prop('checked', true);
            }
            else {
                $('#switchinternetbanking').prop('checked', false);
            }
        }
    }

    function SaveTechnoProducts(RegistrationId) {
        var DebitCard, SMSBanking, MobileBanking, StatementOnEmail, AadhaarCardSeeding, InterntBanking = "false";

        if ($("#switchdebitcard").prop("checked"))
            DebitCard = "true"
        else
            DebitCard = "false"

        if ($("#switchsmsbanking").prop("checked"))
            SMSBanking = "true"
        else
            SMSBanking = "false"

        if ($("#switchmobilebanking").prop("checked"))
            MobileBanking = "true"
        else
            MobileBanking = "false"

        if ($("#switchemail").prop("checked"))
            StatementOnEmail = "true"
        else
            StatementOnEmail = "false"

        if ($("#switchaadhaarcard").prop("checked"))
            AadhaarCardSeeding = "true"
        else
            AadhaarCardSeeding = "false"

        if ($("#switchinternetbanking").prop("checked"))
            InterntBanking = "true"
        else
            InterntBanking = "false"

        technoProducts.RegistrationId = RegistrationId;
        technoProducts.DebitCard = DebitCard;
        technoProducts.SMSBanking = SMSBanking;
        technoProducts.MobileBanking = MobileBanking;
        technoProducts.StatementOnEmail = StatementOnEmail;
        technoProducts.AadhaarCardSeeding = AadhaarCardSeeding;
        technoProducts.InterntBanking = InterntBanking;

        axios.post(technoProductsUrl(), technoProducts, { headers: authHeader() })
            .then(res => {
                if (res.data.responseCode == "OK") {
                    SuccessMessage(res.data.responseMessage);
                }
                else {
                    ErrorMessage(res.data.responseMessage);
                }
            })
    }

    return (
        <React.Fragment>
            <Row style={{ backgroundColor: "white" }}>
                <Col >
                    <div className="table-responsive">
                        <Form style={formBackground} className="needs-validation" onSubmit={(e) => {
                            e.preventDefault();
                            return false;
                        }}>
                            <Row>
                                <Col lg="3"><label style={label}>Debit Cum ATM Card</label></Col>
                                <Col lg="2">
                                    <div className="form-check form-switch mb-3" >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="switchdebitcard"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customSwitch2"
                                        >
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3"><label style={label}>SMS banking</label></Col>
                                <Col lg="2">
                                    <div className="form-check form-switch mb-3" >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="switchsmsbanking"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customSwitch2"
                                        >
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3"><label style={label}>Mobile banking</label></Col>
                                <Col lg="2">
                                    <div className="form-check form-switch mb-3" >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="switchmobilebanking"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customSwitch2"
                                        >
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3"><label style={label}>Statement on E-mail Id</label></Col>
                                <Col lg="2">
                                    <div className="form-check form-switch mb-3" >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="switchemail"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customSwitch2"
                                        >
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3"><label style={label}>Aadhaar card seeding</label></Col>
                                <Col lg="2">
                                    <div className="form-check form-switch mb-3" >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="switchaadhaarcard"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customSwitch2"
                                        >
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="3"><label style={label}>Internet banking</label></Col>
                                <Col lg="2">
                                    <div className="form-check form-switch mb-3" >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="switchinternetbanking"
                                        />
                                        <label
                                            className="form-check-label"
                                            htmlFor="customSwitch2"
                                        >
                                        </label>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg="11">
                                    <Row style={label}>
                                        Note<br></br>
                                        1. The Mobile Number and E-mail ID mentioned will be registered for the SMS,
                                            Mobile Banking and Statement on E-mail ID facility. (If opted by the customer)
                                    </Row><br></br>
                                    <Row style={label}>
                                        2. The service charges for the techno products will be applicable as per the rules and
                                            regulations of the bank.
                                    </Row><br></br>
                                    <Row style={label}>
                                        3. If the answer to point no 5 if yes, kindly fill a separate Aadhar Seeding Form.
                                    </Row><br></br>
                                </Col>
                                <Col lg="1">
                                    <Button id="firstN" style={formButton} type="submit" onClick={() => {
                                        SaveTechnoProducts(RegistrationId);
                                    }} >
                                        Save
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    )
};

TechnoProducts.propTypes = {
    RegistrationId: PropTypes.string
}


export default TechnoProducts
